var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'circle-letter-icon--' + _vm.style,attrs:{"data-test-id":"circle-letter-icon"},on:{"click":_vm.emitClickEvent}},[_vm._v(" "+_vm._s(_vm.value)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }